export default "__VITE_ASSET__qW_1qt_I__"